/**
 * Feature flags for functionality that is merged but not yet fully wired
 * end-to-end (e.g. depends on infrastructure that isn't provisioned yet).
 *
 * Backed by Firebase Remote Config so flags can be toggled instantly from
 * the Firebase console without a rebuild/redeploy (this app is a static CRA
 * build served via Firebase Hosting, so build-time env vars can't be
 * flipped at runtime). See ../services/remoteConfig.js and
 * firebase/remoteconfig.template.json for the parameter definition.
 */
import {useRemoteConfigFlag} from '../services/remoteConfig';

const EVENTGRID_PROVISIONING_FLAG_KEY = 'eventgrid_provisioning_enabled';

// Event Grid / JWT-based SCC provisioning (docker run + SCCCLOUD_KEY flow).
// Keep disabled until the Azure Event Grid namespace + config-delivery
// function are live; until then, edges must still be created with a
// Balena UUID.
export const useEventGridProvisioningEnabled = () =>
  useRemoteConfigFlag(EVENTGRID_PROVISIONING_FLAG_KEY, false);
